import Tooltip from 'tooltip.js';

/**
 * Tooltip для span.js-tooltip-content селекторов
 */

function toolTip() {
    const elements = $( '.js-tooltip-content' );
    const tooltip_instances = [];
    const abbr_active_class = 'hh-data-content-style--active';

    $.each( elements, function ( index, elem ) {

        const tooltip = new Tooltip( elem, {
            trigger: "manual",
            //trigger: "click" or clicked
            template: '' +
            '<div class="hh-article-tooltip" role="tooltip">' +
            '<div class="hh-article-tooltip__close js-tooltip-close">' +
            '<svg class="hh-svg-close"><use xlink:href="#hh-svg-close"></use></svg>' +
            '</div>' +
            '<div class="hh-tooltip-inner"></div>' +
            '</div>',
            innerSelector: '.hh-tooltip-inner',
            title: function () {
                // хак для получения data-title атрибута вместо title
                return elem.getAttribute('data-title');
            },
            //closeOnClickOutside: true
        } );

        tooltip_instances.push( tooltip );

        // Element Show/hide
        $( this ).on( 'click', function () {
            if( tooltip._isOpen ) {
                tooltip.hide();
                $(this).removeClass( abbr_active_class );
                return;
            }

            // Скрываем все открытые tooltips
            tooltip_instances.forEach( function ( item ) {
                if( item._isOpen ) {
                    item.reference.classList.remove( abbr_active_class );
                }

                item.hide();
            } );

            $( this ).addClass( abbr_active_class );
            tooltip.show();
        } );

        // Close tooltip
        // TODO:: Закрывает все tooltip при нажатии на любую кнопку закрыть
        $( 'body' ).on( 'click', '.js-tooltip-close', function () {
            var id = $( this ).parent( '.hh-article-tooltip' ).attr( 'id' );
            $( '[aria-describedby=' + id + ']' ).removeClass( abbr_active_class );
            tooltip.hide();
        } )
    } );
};

$(document).ready(() => {
    toolTip();
});

export default toolTip;
